"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.EditorialNews = void 0;
var _editorialNews = _interopRequireDefault(require("./components/editorial-news"));
exports.EditorialNews = _editorialNews["default"];